import { Component, OnInit } from '@angular/core';
import { AppMetadataHandler } from 'app';
import { FwaDashboardService } from './fwa-dashboard.service';
import { CommonUtilty } from '../../../BaseFramework/core/utilities/commonUtility';
import { NzMessageService } from 'ng-zorro-antd/message';
import { InvestigationService } from 'app/BaseFramework/core/http/investigation.service';
import { environment } from 'environments/environment';

declare const FunnelGraph: any;

@Component({
  selector: 'app-fwa-dashboard',
  templateUrl: './fwa-dashboard.component.html',
  styleUrls: ['./fwa-dashboard.component.scss']
})

export class FwaDashboardComponent implements OnInit {

  constructor(
    public appMetadataHandler: AppMetadataHandler,
    public FwaDashboardService:FwaDashboardService,
    private commonUtility: CommonUtilty,
    private message: NzMessageService,      
    private investigationService: InvestigationService,
  ) { }

  dashboardDateRange: any = [];
  environment = environment;

  ngOnInit() {
    this.setDefaultDateRange();
   }

   setDefaultDateRange(){
    var currentDate = new Date();
    var PreviousYrDate = currentDate.setFullYear(currentDate.getFullYear() - 1);
    this.dashboardDateRange = [new Date(PreviousYrDate), new Date()];
   }
  /* UI :: IMPORTANT NOTE !!!
  * The UI widgets (those with ngx-charts) must be initialized AFTER the view has loaded
  * to prevent erratic display behaviour w.r.t rendering
  */

  widgetReady:boolean = false;
  monthlyOrWeekly:string = 'monthly';

  ngAfterViewInit(): void {
    this.fetchCardsData(this.dashboardDateRange);
    setTimeout(()=>{ this.initFunnel() },850);
    this.fetchMonthlyWeeklyReport();
    this.widgetReady=true;
  }

  /* Date */

  onDashboardDateRangeSelection(e) {
    this.fetchCardsData(e);
  }

  fetchCardsData(selectedDateRange){
    this.FwaDashboardService.fetchCardsData(selectedDateRange).subscribe(resp => {
      // extract data and pass to funnel graph
    });
  }

  fetchMonthlyWeeklyReport(){
    this.FwaDashboardService.fetchMonthlyWeeklyReport().subscribe(resp => {
      
    });
  }

  fraudReasonsList = [];
  claimNumberSearch : string;
  fraudIO = {};
  displayFraudDataCards: boolean = false;
  fraudPredicationMsg = null;

  searchClaim(){
    this.displayFraudDataCards = true;
    this.getColorCode();      
   
    this.fraudReasonsList.push('Agent PAN number is not black listed.');
    this.fraudReasonsList.push('Primary hospital and claim hospitalization network is present.');
    this.fraudReasonsList.push('Claim hospitalization network is present.');
    this.fraudReasonsList.push('No negative postal code and Claim hospitalization network is present.');
    this.fraudReasonsList.push('Primary hospital is present.');
    
    /*this.FwaDashboardService.fetchFWADataAgainstClaimNumber(this.claimNumberSearch).subscribe(resp => {
      this.fraudIO = this.commonUtility.isArrayIterable(resp) ? resp.find(e=> true) : resp;

      if (environment && environment.demo) {
        this.fraudIO['predictionProbabilityPercent'] = this.generateRandom();
      }
      //this.displayFraudDataCards = true;
      // this.getColorCode();      
      // for(let i=1; i <=5; i++){
      //   if(this.fraudIO['Reason '+i]){
      //     this.fraudReasonsList.push(this.fraudIO['Reason '+i]);
      //   }
      // }
    });*/

    this.FwaDashboardService.fetchClaimByClaimNum(this.claimNumberSearch).subscribe(resp => {
      if(resp){
        this.fraudPredicationMsg = null;
        if(resp && resp['claimDO'] && resp['claimDO']['claimNum']){
          resp['id'] = resp['claimDO']['claimNum'];
        }
        else{
          resp['id'] = (Math.random() * 10).toString();
        }
    
        let request ={
          "product_type": "Health_Claims",
          "business_process":"FWARISKANALYSIS",
          "module_name": "RIGHTCREDIT",
          "mms_claim_data": resp
        }

        this.investigationService.claimFraudPrediction(request).subscribe(resp => {
          if(resp && Object.keys(resp).length){
            this.fraudPredicationMsg = null;
            this.fraudIO = this.commonUtility.isArrayIterable(resp) ? resp.find(e=> true) : resp;
            this.getColorCode();
          }else{
            this.fraudPredicationMsg = 'Unexpected error occurred. Please try again later or contact your system administrator.';
          }
        });

      }else{
        this.fraudPredicationMsg = 'Unexpected error occurred. Please try again later or contact your system administrator.';
      }
    });
  }

  generateRandom(maxLimit = 100){
    let rand = Math.random() * maxLimit;  
    rand = Math.floor(rand); 
    return rand;
  }

  getColorCode(){
    if(this.fraudIO){
      let val = this.fraudIO['predictionProbabilityPercent'];
      switch(true){
        case (val < 25):
          this.fraudIO['color'] = '#55c120';
          break;
        case (val > 25 && val < 75):
          this.fraudIO['color'] = '#ef9f27';
          break;
        case (val > 75):
          this.fraudIO['color'] = '#d52b2b';
          break;
        default:
          this.fraudIO['color'] = '#1890ff';
          break;
      }
    }
  }

  /* Functions for getting Gauge values */
  getFraudPropensity = (percent: number) => `${percent}`;
  getRiskValue = (percent: number) => percent > 70 ? 'High' : percent < 70 && percent > 25 ? 'medium' : 'Low';

  selectedTrigger:string;
  searchFromTrigger: string;

  fetchTriggers(){
    this.FwaDashboardService.fetchTriggersData(this.selectedTrigger).subscribe(resp => {
      
    });
  }
  passwordVisible: boolean = false;
  isRetrainModelPopup : boolean = false;
  enteredOTP;
  showRetrainPopup(){
    this.isRetrainModelPopup = true;
  }

  callToRetrainModel(){
    if(this.enteredOTP == this.FwaDashboardService.masterData){

      this.currentRetrainStatus = "Training in Progress";
      this.trainingInProgress = true;
      this.message.create('success', `Training started successfully!`);
      this.isRetrainModelPopup = false;

      let request = {
        "product_type": "HEALTH_PreAuth",
        "business_process": "FWARISKANALYSIS",
        "module_name": "RIGHTCREDIT"
      }

      this.investigationService.retrainingFWA(request).subscribe(resp => {
        this.currentRetrainStatus = resp;  
        this.trainingInProgress = false;      
      });
    }else{
      this.message.create('error', `Invalid OTP`);
    }
  }

  cancelRetrainModelPopup(){
    this.isRetrainModelPopup = false;
  }

  currentRetrainStatus = 'Last training done on 22 Apr 2022'; // another value will be 'Last trained on *some date*'
  trainingInProgress: boolean = false;
  /* ====================================== */
  /* UI COLOR SCHEME SELECTION AND SETTING  */
  colorScheme = {
    name: 'horizon',
    selectable: true,
    group: 'Continuous',
    domain: ["#647c8a", "#3f51b5", "#2196f3", "#00b862", "#85a711", "#b1bd0d", "#5797cb", "#d276be", "#ac4632", "#0ba3d4", "#647c8a", "#3f51b5", "#2196f3", "#00b862", "#85a711", "#b1bd0d"]
  };

  /* ====================================== */
  /* Data */
  
  dataCARDS: any[] = [
    {
      "name": "Proposal",
      "value": "15,389",
      "breakup": [
        {key: "Direct Sales", value: "4,020"},
        {key: "Agents", value: "6,005"},
        {key: "Paper", value: "3,001"},
        {key: "Other Channels", value: "2,363"}
      ]
    },
    {
      "name": "Underwriting",
      "value": "14,457",
      "breakup": [
        {key: "Auto Underwriting", value: "9,167"},
        {key: "Manual Underwriting", value: "5,290"},
      ]
    },
    {
      "name": "FWA Triggered",
      "value": "4,711",
      "breakup": [
        {key: "High Risk", value: "872"},
        {key: "Medium Risk", value: "1,045"},
        {key: "Low Risk", value: "2,794"},
      ]
    },
    {
      "name": "Rejected Due To Actual Frauds",
      "value": "2,711",
      "breakup": []
    },
    {
      "name": "Policies Issued",
      "value": "8,321",
      "breakup": [
        {key: "Direct Sales", value: "2,120"},
        {key: "Agents", value: "2,547"},
        {key: "Paper", value: "1,985"},
        {key: "Other Channels", value: "1,669"}
      ]
    }
    /*{
      "name": "Claims",
      "value": "4,064",
      "breakup": [
        {key: "Claims", value: "2,890"},
        {key: "Pre-Auth", value: "1,174"},
      ]
    },
    {
      "name": "Investigation",
      "value": "662",
      "breakup": [
        {key: "Closed", value: "426"},
        {key: "Work-in-progress", value: "236"},
      ]
    },
    {
      "name": "Fraudulent Claims",
      "value": "152",
      "breakup": [
        {key: "Hospital", value: "82"},
        {key: "Pharmacy", value: "46"},
        {key: "Advisor", value: "24"},
      ]
    },*/
  ];

  colorScheme1 = {
    domain: ['#5AA454', '#E44D25', '#CFC0BB', '#7aa3e5', '#a8385d', '#aae3f5']
  };

  monthlyWeeklyReport = {
    monthly: [
      {
        name: 'Months',
        series:[
          { name: "Jan", value: 366 },
          { name: "Feb", value: 543 },
          { name: "March", value: 58 },
          { name: "April", value: 3465 },
          { name: "May", value: 25 },
          { name: "June", value: 383 },
          { name: "July", value: 457 },
          { name: "Aug", value: 100 },
          { name: "Sept", value: 453 },
          { name: "Oct", value: 996 },
          { name: "Nov", value: 357 },
          { name: "Dec", value: 141 }
        ]
      }
    ],
    daily: [
      {
        name: 'Days',
        series:[
          { name: "Monday", value: 12 },
          { name: "Tuesday", value: 22 },
          { name: "Wednesday", value: 66 },
          { name: "Thursday", value: 93 },
          { name: "Friday", value: 44 },
          { name: "Saturday", value: 63 },
          { name: "Sunday", value: 22 }
        ]
      }
    ]
  }

  MLPredictionVsActualResult = [
    {
      "name": "Machine Learning Prediction",
      "series": [
        {
          "name": "2018",
          "value": 41300
        },
        {
          "name": "2019",
          "value": 38977
        },
        {
          "name": "2020",
          "value": 29088
        },
        {
          "name": "2021",
          "value": 45234
        },
        {
          "name": "2022",
          "value": 32000
        }
      ]
    },
  
    {
      "name": "Actual Result",
      "series": [
        {
          "name": "2018",
          "value": 48000
        },
        {
          "name": "2019",
          "value": 40867
        },
        {
          "name": "2020",
          "value": 42900
        },
        {
          "name": "2021",
          "value": 45600
        },
        {
          "name": "2022",
          "value": 31900
        }
      ]
    }
  ];


  /* Data */
  clusters = [
    { id: 1, name: "Hospital", type:"cluster", severity:"high", contribution: 32},
    { id: 2, name: "Policy and Insured", type:"cluster", severity:"medium", contribution: 26 },
    { id: 3, name: "Advisor", type:"cluster", severity:"medium", contribution: 12 },
    { id: 4, name: "Sales Person", type:"cluster", severity:"low", contribution: 8 },
    { id: 5, name: "Diagnosis Grouper", type:"cluster", severity:"low", contribution: 3 },
  ]
  // dataSet = DATA_DFC.top;

  /* Search */
  searchTerm:string = '';
  isSearching = false;
  performSearch() {
    this.isSearching = true;
    this.dataSet = this.Shuffle(this.dataSet); /* Fake sort */
    this.dataSet = this.dataSet.sort(() => Math.random() - 0.15 ); /* Fake sort */
    setTimeout(()=>{this.isSearching = false;},800);
  }
  Shuffle(o) {
    for(let j, x, i = o.length; i; j = parseInt(String(Math.random() * i)), x = o[--i], o[i] = o[j], o[j] = x);
    return o;
  };


  dataSet = [
    // {"cluster":"Hospital","message":"Higher Rejections from this Provider","invConfirmation":"true","invStatus":"na","invRemarks":"-","probability":"Higher the rejection at a Provider level, higher is the probability of next claim being rejected","scenario":"Past claim experience Status like with minimum number of claims like 5 or 10, etc  \n1. Approved \n2. Rejected \n3. Under Query \n\nDefine threshold overall and then compare within also\nThis should vary at Provider Type also like different threshold for Primary, Secondary and Tertiary Providers."},
    // {"cluster":"Hospital","message":"Previously identified Fraudulent claims from this Provider","invConfirmation":"true","invStatus":"na","invRemarks":"-","probability":"Even if 1 claim rejected due to this, higher is the probability","scenario":"Past claim experience in terms of any claim rejected due to fraud, waste and or abuse\nIf yes, high score to be given"},
    // {"cluster":"Hospital","message":"From Caution Provider","invConfirmation":"true","invStatus":"fraud","invRemarks":"Checked and verified","probability":"Higher","scenario":"Caution Hospital"},
    // {"cluster":"Hospital","message":"Excess Length of Stay (LOS)","invConfirmation":"true","invStatus":"fraud","invRemarks":"Checked and verified","probability":"Higher the LOS as compared to average, higher is the probability of waste","scenario":"Average Length of Stay (LOS) comparison\nFor the same ICD and CPT / PCS Grouper"},
    // {"cluster":"Hospital","message":"Excess claimed amount","invConfirmation":"true","invStatus":"fraud","invRemarks":"Checked and verified","probability":"Higher the ACS as compared to average, higher is the probability of waste","scenario":"Average Claim Size (ACS) comparison\nFor the same ICD and CPT / PCS Grouper"},
    {"cluster":"Advisor","message":"Higher Loss ratio of this agent","invConfirmation":"pending","invStatus":"pending","invRemarks":"-","probability":"Higher the Loss ratio, higher is chance of fraud","scenario":"Loss ratio of this Advisor\nRetail - At a Portfolio level \nGroup - At a advisor and then at a Group level. \n \nDefine threshold overall and then compare within also"},
    {"cluster":"Advisor","message":"Higher Frequency from this agent","invConfirmation":"pending","invStatus":"pending","invRemarks":"-","probability":"Higher the frequency, higher is chance of fraud","scenario":"Frequency\nRetail - At a Portfolio level \nGroup - At a advisor and that Group level\n\nDefine Threshold"},
    {"cluster":"Advisor","message":"Higher claims of Agent in this Provider","invConfirmation":"pending","invStatus":"pending","invRemarks":"-","probability":"Higher","scenario":"Advisor claiming from the same Provider \nThreshold to be defined"},
    {"cluster":"Policy and Insured","message":"Claim from insured early on","invConfirmation":"true","invStatus":"non-fraud","invRemarks":"Checked and verified ","probability":"Lower the Tenure, higher is the probability","scenario":"Tenure"},
    {"cluster":"Policy and Insured","message":"Claim from Insured belonging to a pin code with high fraudulent claims","invStatus":"non-fraud","invConfirmation":"true","invRemarks":"Checked and verified ","probability":"Understand which pincodes are highest or higher conducting fraud","scenario":"Loss Location"},
    {"cluster":"Policy and Insured","message":"Claim from Insured belonging to a pin code with high rejection ratio","invStatus":"na","invConfirmation":"false","invRemarks":"-","probability":"Understand which pincodes are highest Rejection ratio","scenario":"Loss Location"}
  ]

  graphHeight = 350;
  graph = null;
  initFunnel() {
    // Source: https://github.com/greghub/funnel-graph-js
    this.graph = new FunnelGraph({
      direction: 'horizontal',
      height: this.graphHeight,
      container: '.funnel-container',
      gradientDirection: 'vertical',
      data: {
        //labels: ['Policies', 'Claims', 'FWA Triggered', 'Investigation', 'Fraudulent'],
        labels: ['Proposal','Underwriting', 'FWA Triggered','Rejected Due To Actual Frauds','Policies'],
        subLabels: ['Direct Sales','Agents','Other channels'],
        //subLabels:[],
        colors: [
          ['rgb(100, 124, 138)', 'rgb(114,151,169)', 'rgb(75,105,117)'],
          ['#03a9f4','#32bbf1'],
          ['rgb(63, 81, 181)','rgb(93,111,239)','rgb(81,102,222)'],
        ],
        // values: [
        //   [2020, 4005, 6001], // Policies via ['Direct','Agents','Other channels']
        //   [1602, 1200, 1262], // Claims
        //   [625, 157, 289], // Triggered
        //   [347, 116, 199], // Investigation
        //   [36, 57, 59], // Fraudulent
        // ]
        values: [
          [4020, 6005, 3001], // Policies via ['Direct','Agents','Other channels']
          [9167, 5290], // Triggered
          [872, 1045, 2794], // Triggered
          [625, 157, 289], // Triggered
          [2120, 2547, 1985] // Triggered
        ]
      },
      displayPercent: true,
    });
    this.graph.draw();
  }

}

